export function handleAnyClick(el) {
  const key = el.dataset.filterAny || el.dataset.filterClear;

  if (!key) return;

  document.querySelectorAll(`input[data-filter-group='${key}']`).forEach((cb) => {
    cb.checked = false;
  });

  el.checked = true;
}

export function initFilters() {
  document.addEventListener("change", (e) => {
    const groupKey = e.target.dataset.filterGroup;

    if (!groupKey) return;

    const values = document.querySelectorAll(`input[data-filter-group="${groupKey}"]:checked`);

    const any = document.querySelector(`input[data-filter-any="${groupKey}"]`);

    if (values.length > 0) {
      if (any) any.checked = false;
    } else {
      if (any) any.checked = true;
    }
  });
}
